
export default {
  name: 'adTextEmpty'
}
